/****************************************项目配置***************************************/

export const CONSOLE_RESPONSE_ENABLE = false;
export const CONSOLE_REQUEST_ENABLE = false;

// 是否强制所有请求访问本地 MOCK，
export const AXIOS_MOCK_ENABLE = false;

// 通过给axios配置不同的baseURL，来区分是生产接口还是mock接口
export const AXIOS_BASE_URL = "";
export const AXIOS_BASE_URL_MOCK = "/mock";

// axios 默认配置
export const AXIOS_DEFAULT_CONFIG = {
  timeout: 20000,
  maxContentLength: 2000,
  headers: {},
  baseURL: AXIOS_MOCK_ENABLE ? AXIOS_BASE_URL_MOCK : AXIOS_BASE_URL
};

// API 默认配置
export const API_DEFAULT_CONFIG = {
  debug: false,
  sep: "/"
};

// CONST 默认配置
export const CONST_DEFAULT_CONFIG = {
  sep: "/"
};

// axios 额外配置
export const AXIOS_OPTIONS_CONFIG = {
  needloading: false,
  contenttype: "json"
};

//合作品牌
export const brands = [
  {
    key: 1,
    values: [
      { name: "中国平安", url: "/assets/images/brands/1/1.png" },
      { name: "中国阳光", url: "/assets/images/brands/1/2.png" },
      { name: "太平洋保险", url: "/assets/images/brands/1/3.png" },
      { name: "中国人民保险", url: "/assets/images/brands/1/4.png" },
      { name: "中国人寿", url: "/assets/images/brands/1/5.png" },
      { name: "中国太平", url: "/assets/images/brands/1/6.png" },
      { name: "中国人民保险", url: "/assets/images/brands/1/7.png" },
      { name: "复星联合健康保险", url: "/assets/images/brands/1/8.png" },
      { name: "百年人寿", url: "/assets/images/brands/1/9.png" },
      { name: "国富人寿", url: "/assets/images/brands/1/10.png" },
      { name: "瑞泰人寿", url: "/assets/images/brands/1/11.png" },
      { name: "横琴人寿", url: "/assets/images/brands/1/12.png" },
      { name: "信泰人寿", url: "/assets/images/brands/1/13.png" },
      { name: "昆仑健康保险", url: "/assets/images/brands/1/14.png" },
      { name: "三峡人寿", url: "/assets/images/brands/1/15.png" }
    ]
  },
  {
    key: 2,
    values: [
      { name: "华贵保险", url: "/assets/images/brands/2/1.png" },
      { name: "上海人寿", url: "/assets/images/brands/2/2.png" },
      { name: "众安保险", url: "/assets/images/brands/2/3.png" },
      { name: "海保人寿", url: "/assets/images/brands/2/4.png" },
      { name: "弘康人寿", url: "/assets/images/brands/2/5.png" },
      { name: "瑞华保险", url: "/assets/images/brands/2/6.png" },
      { name: "长生人寿", url: "/assets/images/brands/2/7.png" },
      { name: "光大永明人寿", url: "/assets/images/brands/2/8.png" },
      { name: "中信保诚", url: "/assets/images/brands/2/9.png" },
      { name: "亚太财险", url: "/assets/images/brands/2/10.png" },
      { name: "安心保险", url: "/assets/images/brands/2/11.png" },
      { name: "华泰保险", url: "/assets/images/brands/2/12.png" },
      { name: "爱心人寿", url: "/assets/images/brands/2/13.png" },
      { name: "中荷人寿", url: "/assets/images/brands/2/14.png" },
      { name: "德华安顾人寿", url: "/assets/images/brands/2/15.png" }
    ]
  },
  {
    key: 3,
    values: [
      { name: "和泰人寿", url: "/assets/images/brands/3/1.png" },
      { name: "和谐健康保险", url: "/assets/images/brands/3/2.png" },
      { name: "信美相互", url: "/assets/images/brands/3/3.png" },
      { name: "国华人寿", url: "/assets/images/brands/3/4.png" },
      { name: "鼎诚人寿", url: "/assets/images/brands/3/5.png" },
      { name: "安达保险", url: "/assets/images/brands/3/6.png" },
      { name: "京东安联", url: "/assets/images/brands/3/7.png" },
      { name: "安盛天平", url: "/assets/images/brands/3/8.png" },
      { name: "融盛保险", url: "/assets/images/brands/3/9.png" },
      { name: "中国大地保险", url: "/assets/images/brands/3/10.png" },
      {
        name: "众惠财产相互保险社",
        url: "/assets/images/brands/3/11.png"
      },
      { name: "华农保险", url: "/assets/images/brands/3/12.png" },
      { name: "中华保险", url: "/assets/images/brands/3/13.png" },
      { name: "永安保险", url: "/assets/images/brands/3/14.png" },
      { name: "国任保险", url: "/assets/images/brands/3/15.png" }
    ]
  },
  {
    key: 4,
    values: [
      { name: "天安财险", url: "/assets/images/brands/4/1.png" },
      { name: "泰康", url: "/assets/images/brands/4/2.png" },
      { name: "招商信诺", url: "/assets/images/brands/4/3.png" },
      { name: "工银安盛人寿", url: "/assets/images/brands/4/4.png" },
      { name: "富德生命健康", url: "/assets/images/brands/4/5.png" },
      { name: "渤海人寿", url: "/assets/images/brands/4/6.png" },
      { name: "中韩人寿", url: "/assets/images/brands/4/7.png" },
      { name: "天安人寿", url: "/assets/images/brands/4/8.png" }
    ]
  }
];
//骆驼测评小程序各公众号唤起地址
export const cePingMiniUrl = {
  jiangbao: "weixin://dl/business/?t=6V6WrGJShXs",
  cebao: "weixin://dl/business/?t=XFmYVdVxUNr",
  shuobao: "weixin://dl/business/?t=CkpB5NIKzIu",
  xuanbao: "weixin://dl/business/?t=HTreLNWjQ9i",
  ceshi: "weixin://dl/business/?t=QyGljpXxGyk"
};
